export default __webpack_public_path__ + "static/media/chat.d5d8ec22.wav";